import logo from "../../assets/images/logo-inverted.svg";
import { PopupButton } from "@typeform/embed-react";
import "./Header.scss";

const Header = () => (
  <header className="header">
    <img src={logo} alt="Zeesta Labs Logo" />
    <PopupButton id="e5FdASgO">Join our study</PopupButton>
  </header>
);

export default Header;
